import React from 'react';
import { FadeIn } from './FadeIn';
import { RouteLink } from '../lib/router';
import { SafeImage } from './SafeImage';
export function Hero() {
  return <section className="relative flex min-h-[82vh] flex-col justify-end overflow-hidden bg-charcoal px-6 pb-24 pt-24 md:min-h-[88vh] md:px-12" data-id="element-371" data-mp="ehtiju9l4xmr">
      <div className="absolute inset-0 z-0" data-id="element-372" data-mp="4m8ku8bjujit">
        <SafeImage src="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" alt="Sauna at night with steam rising from the chimney" className="h-full w-full object-cover object-center" data-id="element-373" data-mp="4njq6ckn7zc1" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/30 mix-blend-multiply" data-id="element-374" data-mp="3d1a83izra9cr" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/50 to-transparent" data-id="element-375" data-mp="3825wymt9u1js" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl" data-id="element-376" data-mp="3j9k9t8cxxbej">
        <FadeIn delay={0.2} data-id="element-377" data-mp="3o7lvm11r3otp">
          <p className="mb-6 text-xs font-medium uppercase tracking-[0.2em] text-sand/80" data-id="element-378" data-mp="3o7vhbcfrj9tl">
            Pines Retreat · Kfar Pines, Israel
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-379" data-mp="3e9fuhlnrqmpw">
          <h1 className="mb-8 pb-1 font-serif text-5xl leading-[1.05] text-offwhite md:text-7xl lg:text-8xl" data-id="element-380" data-mp="3e8efx77jni3f">
            Slow down. Gather.
            <br data-id="element-381" data-mp="30fy7trzsctvn" />
            Reconnect.
          </h1>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-382" data-mp="359j8xswoe3z2">
          <p className="mb-12 max-w-2xl text-lg font-light leading-relaxed text-sand/90 md:text-xl" data-id="element-383" data-mp="35audhuxy3fr8">
            Boutique accommodation, sauna, natural cedar wood hot tub, cold water and retreat experiences in nature.
          </p>
        </FadeIn>

        <FadeIn delay={0.8} className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-4" data-id="element-384" data-mp="2hix1o3uhwnq4">
          <RouteLink to="/stay" className="inline-flex items-center justify-center whitespace-nowrap rounded-sm bg-ember px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-ember/90" data-id="element-385" data-mp="2ll0g91cgo8fm">
            Stay Overnight
          </RouteLink>
          <RouteLink to="/membership" className="inline-flex items-center justify-center whitespace-nowrap rounded-sm border border-cream/30 bg-transparent px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-cream/10" data-id="element-386" data-mp="ibp0ush8d0y2">
            Pines Membership
          </RouteLink>
          <RouteLink to="/space" className="inline-flex items-center justify-center whitespace-nowrap rounded-sm border border-cream/30 bg-transparent px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-cream/10" data-id="element-387" data-mp="16346ov87u0e2">
            Retreat Space
          </RouteLink>
        </FadeIn>
      </div>
    </section>;
}